import '@google/model-viewer';
import axios from 'axios';
import * as nodePath from 'path';
import React, { Component } from 'react';
import { AiFillInfoCircle, FiInfo, IoCloseCircle } from 'react-icons/all';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app
import store from '../../../../store';
import { changeSettingValue } from '../../../setting/action';
import Info3DView from './Info3DView';
import InfoAPIView from './InfoAPIView';
import InfoHtmlIndoorView from './InfoHtmlIndoorView';
import InfoHtmlView from './InfoHtmlView';
import './meta.style.css';
import './style.css';

export default class InfoTool extends Component {
    constructor() {
        super();
        this.state = {
            toggleDetail: false,
            isHiddenInfoPanel: false,
            infoPanel: {},
        };
        this.element = {};
    }

    componentWillMount() {
        window.showInfo = InfoTool.showInfo.bind(this);
        window.closeInfo = InfoTool.closeInfo.bind(this);
    }

    static showInfo(type, path) {
        var localPath = nodePath.join(`${process.env.PUBLIC_URL}/data/`, path);
        if (type == '3d') {
            this.state.infoPanel[type] = <Info3DView filePath={localPath} />;
        } else if (type == '3d_web') {
            this.state.infoPanel[type] = <Info3DView filePath={path} />;
        } else if (type == 'html') {
            this.state.infoPanel[type] = (
                <InfoHtmlView
                    filePath={localPath}
                    onCollapse={(isHiddenInfoPanel) => {
                        this.setState({ isHiddenInfoPanel });
                        if (
                            isHiddenInfoPanel &&
                            this.state.infoPanel['3d'] == null &&
                            this.state.infoPanel['3d_view'] == null
                        )
                            window.closeInfo();
                    }}
                />
            );
        } else if (type == 'html-indoor') {
            this.state.infoPanel[type] = (
                <InfoHtmlIndoorView
                    filePath={localPath}
                    onCollapse={(isHiddenInfoPanel) => {
                        this.setState({ isHiddenInfoPanel });
                        if (
                            isHiddenInfoPanel &&
                            this.state.infoPanel['3d'] == null &&
                            this.state.infoPanel['3d_view'] == null
                        )
                            window.closeInfo();
                    }}
                />
            );
        } else if (type == 'api') {
            this.state.infoPanel[type] = (
                <InfoAPIView
                    api={path}
                    onCollapse={(isHiddenInfoPanel) => {
                        this.setState({ isHiddenInfoPanel });
                        if (
                            isHiddenInfoPanel &&
                            this.state.infoPanel['3d'] == null &&
                            this.state.infoPanel['3d_view'] == null
                        )
                            window.closeInfo();
                    }}
                />
            );
        }
        this.setState({ toggleDetail: true, isHiddenInfoPanel: false });
        store.dispatch(changeSettingValue('isToggleFull', true));
    }

    static closeInfo() {
        store.dispatch(changeSettingValue('isToggleFull', false));
        this.setState({ infoPanel: {}, toggleDetail: false });
    }

    showSceneMeta() {
        this.setState({ toggleDetail: !this.state.toggleDetail });
    }

    getCloseBtnView() {
        if (!this.state.toggleDetail) return;
        return (
            <div className="btn close-btn" onClick={() => window.closeInfo()}>
                <IoCloseCircle />
            </div>
        );
    }

    getIconView() {
        if (window.config?.toolbar?.info?.icon != null)
            return (
                <img
                    src={`${process.env.PUBLIC_URL}/data/${window.config.toolbar?.info?.icon}`}
                />
            );
        return this.state.toggleDetail ? <AiFillInfoCircle /> : <FiInfo />;
    }

    render() {
        var hiddenInfoPanel = this.state.isHiddenInfoPanel
            ? ' hidden-info-panel'
            : '';
        return [
            window.config.toolbar?.info?.display ? (
                <div className="info-type-container tool-item" id="tool-info">
                    <div
                        className="item-icon"
                        onClick={this.showSceneMeta.bind(this)}
                    >
                        {this.getIconView.call(this)}
                    </div>
                </div>
            ) : null,
            <div className={'info-container' + hiddenInfoPanel}>
                <div className="mask"></div>
                {this.state.toggleDetail
                    ? Object.values(this.state.infoPanel)
                    : null}
                {this.getCloseBtnView.call(this)}
            </div>,
        ];
    }
}
